import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { authGuard } from '../../core/guards';
import { StockTransferComponent } from './stock-transfer/stock-transfer.component';

const routes: Routes = [
  {
    path: 'incoming',
    component: StockTransferComponent,
    canActivate: [ authGuard ]
  },
  {
    path: 'outgoing',
    component: StockTransferComponent,
    canActivate: [ authGuard ]
  },
  {
    path: '',
    component: StockTransferComponent,
    canActivate: [ authGuard ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StockTransferRoutingModule { }
